import { render, staticRenderFns } from "./AssignBookingRow.vue?vue&type=template&id=4880042e"
import script from "./AssignBookingRow.vue?vue&type=script&lang=js"
export * from "./AssignBookingRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports